import { Controller } from 'libraries/front-end-core/core/Router'
import getUrl from 'libraries/front-end-core/core/url'
import { DOCUMENTS_MENU } from 'constants/controllers'
import Main from './Main'
import Header from './Header'

export default new Controller({
  name: DOCUMENTS_MENU,
  route: 'documents(#:aol)', // our current router doesn't seperate the hash
  controller (Router, { params: { aol } }, render) {
    const pageId = getUrl(DOCUMENTS_MENU)

    render(
      { Main, Header },
      {
        searchType: 'documents',
        aol
      },
      {
        searchType: 'documents',
        className: 'documents',
        pageId
      }
    )

    return pageId
  }
})
